import { LockIcon } from 'types/graphql-base'
import type { SvgIconComponent } from 'shared/types'
import {
  Barrier,
  Door,
  Garage,
  Gate,
  Handle,
  Lift,
  Padlock,
  Speedgate,
} from 'shared/assets'

const LockIconMapping: Record<LockIcon, SvgIconComponent> = {
  [LockIcon.Barrier]: Barrier,
  [LockIcon.Door]: Door,
  [LockIcon.Garage]: Garage,
  [LockIcon.Gate]: Gate,
  [LockIcon.Lock]: Padlock,
  [LockIcon.Handle]: Handle,
  [LockIcon.Lift]: Lift,
  [LockIcon.Speedgate]: Speedgate,
}

// The API may return an icon this client does not know yet
export const getLockIconComponent = (icon: LockIcon) =>
  LockIconMapping[icon] || Door
